module.exports = __webpack_public_path__ + "f5088687f23a4c2d37e75427364a26f1.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/187.png
// module id = 1770
// module chunks = 2